import { call, put, select } from 'redux-saga/effects';

import { sessionExpired } from './authModule';
import { getIsAuthenticated } from './authSelectors';
import { fetchIdentity } from './authApi';










export const getErrorStatus = error => (
    error && error.response ? error.response.status : undefined
);




export function* isExpiredSessionError(error) {
    if (getErrorStatus(error) !== 401) {
        return false;
    }
    return yield select(getIsAuthenticated);
}







export function* handleExpiredSession(error) {
    const expired = yield* isExpiredSessionError(error);
    if (expired) {
        yield put(sessionExpired());
    }
    return expired;
}














export function* detectExpiredSession() {
    const isAuthenticated = yield select(getIsAuthenticated);
    if (!isAuthenticated) {
        return false;
    }
    let authenticated = true;
    try {
        ({ authenticated } = yield call(fetchIdentity));
    } catch (error) {
        return false;
    }
    if (!authenticated) {
        yield put(sessionExpired());
        return true;
    }
    return false;
}
